"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsModelCached = void 0;
const useOdrModels_1 = require("./useOdrModels");
function useIsModelCached(id) {
    var _a;
    const models = (0, useOdrModels_1.useOdrModels)();
    const model = models === null || models === void 0 ? void 0 : models.find(({ identifier }) => identifier === id);
    return (_a = model === null || model === void 0 ? void 0 : model.isCached) !== null && _a !== void 0 ? _a : false;
}
exports.useIsModelCached = useIsModelCached;
